module.exports = __webpack_public_path__ + "media/images/parallax/illustration-do-middleground-8ea6d2e8d8472e0ddf45d0ccecce86ac.png";